import { render, staticRenderFns } from "./ProviderRevenueDonutChart.vue?vue&type=template&id=042b1a8c&scoped=true&"
import script from "./ProviderRevenueDonutChart.vue?vue&type=script&lang=js&"
export * from "./ProviderRevenueDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b1a8c",
  null
  
)

export default component.exports